import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
  realm: "s4",
  url: "https://id5.budding.ai/auth/",
  clientId: "bapp",
});
export default keycloak;
